import { gql, useQuery } from "@apollo/client";

export const RemoveItemFromMachine = gql`
	mutation RemoveItemFromMachine(
		$id: String!
		$status: String!
		$items: [String]!
	) {
		removeItemFromMachine(id: $id, status: $status, items: $items) {
			_id
		}
	}
`;
